import { render, staticRenderFns } from "./SeatsSelector.vue?vue&type=template&id=9d9b13fe&"
import script from "./SeatsSelector.vue?vue&type=script&lang=js&"
export * from "./SeatsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports